module.exports = __webpack_public_path__ + "static/media/AX.70728d33.png";